import { FormEvent, useState } from 'react';
import { api } from '../../services/apiClient';
import logo from '../../assets/logo-badge.webp';

// Página pública "olvidé mi contraseña". Respuesta SIEMPRE uniforme (no revela si la cuenta existe).
// La ENTREGA del enlace la hace el estudio manualmente (WhatsApp) en el cutover; aquí solo se solicita.
export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      // Núcleo: /api/auth/forgot espera { email } (resuelve tenant por host).
      await api.post('/auth/forgot', { email: identifier.trim() });
    } catch { /* respuesta uniforme: nunca mostramos error */ }
    setBusy(false);
    setSent(true);
  }

  return (
    <div className="force-light relative flex min-h-full items-center justify-center overflow-hidden bg-canvas p-4 text-content">
      <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-accent/30 blur-3xl" />
      <div className="relative w-full max-w-sm rounded-2xl border border-line bg-surface p-8 shadow-xl">
        <div className="mb-6 flex flex-col items-center gap-3">
          <div className="relative">
            <div className="absolute inset-0 -m-1 rounded-full bg-accent/40 blur-md" />
            <img src={logo} alt="Let's Move Dance & Fitness" className="relative h-24 w-24 rounded-full bg-white object-contain shadow-md ring-4 ring-accent/60" />
          </div>
          <div className="text-center">
            <h1 className="font-display text-2xl font-extrabold tracking-wide text-content">LET'S MOVE</h1>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-content-3">Dance &amp; Fitness</p>
          </div>
        </div>

        {sent ? (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-5 text-center text-sm text-emerald-800">
            Si tu cuenta existe, el estudio te hará llegar un enlace para restablecer tu contraseña.
            <div className="mt-4">
              <a href="/login" className="font-semibold text-brand-blue underline">Volver a iniciar sesión</a>
            </div>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <p className="mb-4 text-center text-sm text-content-2">
              Escribe tu usuario o correo y el estudio te ayudará a recuperar tu acceso.
            </p>
            <label className="mb-1 block text-sm font-medium text-content-2">Usuario / Correo</label>
            <input type="text" autoFocus value={identifier} onChange={(e) => setIdentifier(e.target.value)}
              className="mb-6 w-full rounded-lg border border-line bg-surface px-3 py-2 text-sm outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/30"
              placeholder="tucorreo@ejemplo.com" />
            <button type="submit" disabled={busy || !identifier}
              className="w-full rounded-lg bg-accent-solid py-2.5 text-sm font-semibold text-on-accent transition hover:bg-accent-solid/90 disabled:cursor-not-allowed disabled:bg-line disabled:text-content-3">
              {busy ? 'Enviando…' : 'Solicitar enlace'}
            </button>
            <div className="mt-4 text-center">
              <a href="/login" className="text-sm text-content-3 underline hover:text-content-2">Volver</a>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
